import { X } from 'lucide-react'

// Shared hover-reveal delete control for atom block NodeViews (image, TOC,
// video). Sits top-right; the parent NodeViewWrapper must be `group relative`.
export function NodeDeleteButton({ onDelete, label }: { onDelete: () => void; label: string }) {
  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      contentEditable={false}
      onClick={event => { event.stopPropagation(); onDelete() }}
      className="absolute right-1.5 top-1.5 z-10 hidden size-6 cursor-pointer items-center justify-center rounded-full bg-background/85 text-foreground shadow group-hover:flex hover:bg-destructive hover:text-destructive-foreground"
    >
      <X className="size-3.5" />
    </button>
  )
}
